export default {

  subjects: (state) => state.subjects,
  classes: (state) => state.classes,
  categories: (state) => state.categories

}